/*******************任务管理*******************/
const taskmanagement = resolve => require(['@/pages/shoppingguide/taskmanagement'], resolve);
const setBasicInfo = resolve => require(['@/pages/shoppingguide/taskmanagement/setTask/setBasicInfo'], resolve);
const setPrize = resolve => require(['@/pages/shoppingguide/taskmanagement/setTask/setPrize'], resolve);
const stepEdit = resolve => require(['@/pages/shoppingguide/taskmanagement/setTask/stepEdit'], resolve);
const taskComplete = resolve => require(['@/pages/shoppingguide/taskmanagement/setTask/taskComplete'], resolve);
const taskDetail = resolve => require(['@/pages/shoppingguide/taskmanagement/setTask/taskDetail'], resolve);


/*******************业绩管理*******************/
const performancemanagement = resolve => require(['@/pages/shoppingguide/performancemanagement'], resolve);
const orderResults = resolve => require(['@/pages/shoppingguide/performancemanagement/orderResults'], resolve);
const pullNewResults = resolve => require(['@/pages/shoppingguide/performancemanagement/pullNewResults'], resolve);
const shareResults = resolve => require(['@/pages/shoppingguide/performancemanagement/shareResults'], resolve);

/*******************提现管理*******************/
const cashManagement = resolve => require(['@/pages/shoppingguide/cashManagement'], resolve);

/*******************实名认证审核*******************/
const realNameAudit = resolve => require(['@/pages/shoppingguide/realNameAudit'], resolve);


export default [
  //任务管理
  {
    path: "/taskmanagement",
    name: "任务管理",
    component: taskmanagement,
    meta: {
      keepAlive: true
    },
  },
  /*任务管理下页面开始*/
  {
    path: "/taskmanagement/setBasicInfo",
    name: "发布任务",
    component: setBasicInfo
  },
  {
    path: "/taskmanagement/setPrize",
    name: "设置任务奖励",
    component: setPrize
  },
  {
    path: "/taskmanagement/stepEdit",
    name: "任务展示设置",
    component: stepEdit
  },
  {
    path: "/taskmanagement/taskComplete",
    name: "任务创建成功",
    component: taskComplete
  },
  {
    path: "/taskmanagement/taskDetail",
    name: "任务详情",
    component: taskDetail
  },
  /*任务管理下页面结束*/
  //业绩管理
  {
    path: "/performancemanagement",
    name: "业绩管理",
    component: performancemanagement
  },
  /*业绩管理下页面开始*/
  {
    path: "/performancemanagement/orderResults",
    name: "订单业绩",
    component: orderResults
  },
  {
    path: "/performancemanagement/pullNewResults",
    name: "拉新业绩",
    component: pullNewResults
  },
  {
    path: "/performancemanagement/shareResults",
    name: "分享达人业绩",
    component: shareResults
  },
  /*业绩管理下页面结束*/
  //提现申请管理
  {
    path: "/cashManagement",
    name: "提现申请管理",
    component: cashManagement
  },
  //实名认证审核
  {
    path: "/realNameAudit",
    name: "实名认证审核",
    component: realNameAudit
  },


]
